<template>
  <ion-page>
    <main-header :back-href="backHref"></main-header>
    <ion-content padding>
      <loading-spinner v-if="loading"></loading-spinner>
      <div v-else>
        <ion-list>
          <ion-item>
            <ion-label>
              {{ stripeCard.brand | ucfirst }} -
              {{ stripeCard.last4 }}
            </ion-label>

            <!-- This is weirdly done for spacing. You can't have an empty class on ion-text, ugh. -->
            <ion-text v-if="ios" class="ion-margin-end">
              Primary:
            </ion-text>
            <span v-else>
              Primary:
            </span>
            <ion-toggle
              color="success"
              @ionChange="isDefault = $event.detail.checked"
              :checked="isDefault"
              :disabled="stripeCard.isDefault"
            ></ion-toggle>
          </ion-item>
        </ion-list>
        <div class="ion-padding">
          <form @submit.prevent="handleSaveCard()">
            <submit-button :submitting="submitting">
              Save Card
            </submit-button>
          </form>
        </div>
        <hr class="divider" />
        <div class="ion-padding ion-text-center">
          <ion-button color="danger" size="small" @click="deleteConfirm()">
            Remove Card
          </ion-button>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { mapGetters } from "vuex";
import StripeCard from "@/models/StripeCard";
import errorAlert from "@/ErrorAlert";
import submittable from "@/mixins/submittable";
import PlatformService from "@/services/Platform";

export default {
  title: "Card Details",

  mixins: [submittable],

  data: function() {
    return {
      loading: true,
      stripeCard: null,
      isDefault: false
    };
  },

  created() {
    const stripeCardId = this.$route.params.id;

    this.$firestore()
      .collection("users")
      .doc(this.user.uid)
      .collection("stripeCards")
      .withConverter(StripeCard.firebaseConverter)
      .doc(stripeCardId)
      .get()
      .then(result => {
        this.stripeCard = result.data();
        this.isDefault = this.stripeCard.isDefault;
      })
      .catch(e => {
        errorAlert(e.message);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    async handleSaveCard() {
      this.startSubmission();
      if (this.isDefault !== this.stripeCard.isDefault) {
        let updateIsDefault = this.$functions().httpsCallable(
          "updateIsDefault"
        );

        try {
          await updateIsDefault({
            stripeCardId: this.stripeCard.id,
            isDefault: this.isDefault
          });
        } catch (error) {
          let message = error.message;
          if (message === "internal") {
            message =
              "There was an internal error and we were unable to process this request.";
          }
          errorAlert(message);
          this.completeSubmission();
          return;
        }
      }

      this.completeSubmission();
      this.successToast("Your card has been updated.");
    },

    deleteConfirm() {
      return this.$ionic.alertController
        .create({
          header: "Delete Card",
          message: "Please confirm that you'd like to delete this card.",
          buttons: [
            {
              text: "Cancel",
              role: "cancel",
              cssClass: "cancel-button"
            },
            {
              text: "Okay",
              cssClass: "okay-button",
              handler: () => {
                this.deleteCard();
              }
            }
          ]
        })
        .then(a => a.present());
    },

    deleteCard() {
      this.$firestore()
        .collection("users")
        .doc(this.user.uid)
        .collection("stripeCards")
        .doc(this.stripeCard.id)
        .delete()
        .then(() => {
          this.successToast("The card has been deleted.");

          this.$router.push({ name: "App: Payment Methods" }).catch(e => e);
        });
    }
  },

  computed: {
    ...mapGetters("auth", ["user"]),

    backHref() {
      return this.$router.resolve({
        name: "App: Payment Methods"
      }).href;
    },

    ios() {
      return !PlatformService.isAndroid();
    }
  }
};
</script>
